import {gql} from '@apollo/client'

export const GET_ALL_SIGNATURE_FORMS_ENTRIES_API = gql`
  query allSignatureFormsEntries(
    $offset: Int
    $before: String
    $after: String
    $first: Int
    $last: Int
    $status: String
    $recipient: String
    $user: String
    $signatureForm: String
    $lead: String
    $policy: String
    $memberPolicy: String
    $contact: String
  ) {
    allSignatureFormsEntries(
      offset: $offset
      before: $before
      after: $after
      first: $first
      last: $last
      status: $status
      recipient: $recipient
      user: $user
      signatureForm: $signatureForm
      lead: $lead
      policy: $policy
      memberPolicy: $memberPolicy
      contact: $contact
    ) {
      pageInfo {
        hasNextPage
        startCursor
        endCursor
      }
      totalCount
      edges {
        node {
          id
          user {
            id
            firstName
            lastName
            email
            cellphone
            avatar
          }
          agent {
            id
            firstName
            lastName
            email
            cellphone
            avatar
          }
          recipient
          lead {
            id
            name
          }
          policy {
            id
            policyName
          }
          member {
            id
            firstName
            lastName
          }
          contact {
            id
            fullName
            firstName
            lastName
          }
          status
          signatureForm {
            id
            name
          }
          renderedHtml
          requestedOn
          signedOn
          ip
          token
          signedPdf
          signatureImage
          signedPdfUrl
          signatureImageUrl
          created
          updated
          logs {
            id
            action
            contact
            user {
              id
              firstName
              lastName
              email
            }
            ipAddress
            region
            browser
            isMobile
            created
          }
        }
      }
    }
  }
`
export const GET_ONE_SIGNATURE_FORM_ENTRY_API = gql`
  query signatureFormsEntryById($id: String) {
    signatureFormsEntryById(id: $id) {
      id
      user {
        id
        firstName
        lastName
        email
        cellphone
        avatar
      }
      agent {
        id
        firstName
        lastName
        email
        cellphone
        avatar
      }
      recipient
      lead {
        id
        name
      }
      policy {
        id
        policyName
      }
      member {
        id
        firstName
        lastName
      }
      contact {
        id
        fullName
        firstName
        lastName
      }
      status
      signatureForm {
        id
        name
      }
      renderedHtml
      requestedOn
      signedOn
      ip
      token
      signedPdf
      signatureImage
      signedPdfUrl
      signatureImageUrl
      created
      updated
    }
  }
`

export const GET_ONE_SIGNATURE_FORM_ENTRY_TOKEN_API = gql`
  query signatureFormsEntryByToken($token: String!) {
    signatureFormsEntryByToken(token: $token) {
      id
      user {
        id
        firstName
        lastName
        email
        cellphone
        avatar
      }
      agent {
        id
        firstName
        lastName
        email
        cellphone
        avatar
      }
      recipient
      lead {
        id
        name
      }
      policy {
        id
        policyName
      }
      member {
        id
        name
      }
      contact {
        id
        fullName
        firstName
        lastName
      }
      status
      signatureForm {
        id
        name
      }
      renderedHtml
      requestedOn
      signedOn
      ip
      token
      signedPdf
      signatureImage
      signedPdfUrl
      signatureImageUrl
      created
      updated
    }
  }
`
